import { RECEIVE_OFFICES, UPDATE_OFFICE, UPDATE_PHOTOS } from '../actions/offices'

export default function offices (state = {}, action) {
	switch (action.type) {
		case RECEIVE_OFFICES :
			return action.offices === null
				? {}
				: {
					...state,
					...action.offices
				}

		case UPDATE_OFFICE :
			const { office } = action

			return {
				...state,
				[office.id]: office
			}

		case UPDATE_PHOTOS :
			const { officeId, photos } = action

			return {
				...state,
				[officeId]: {
					...state[officeId],
					photos: photos
				}
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/offices.js